import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import { connect, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Element } from "react-scroll";
import menuBg from "../../assets/images/bg/menu/resources.svg";
import angleLeft from "../../assets/images/icons/angle-left.svg";
import angleRight from "../../assets/images/icons/angle-right.svg";
import Footer from "../../components/footer";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import "../../components/home/resources/style.scss";
import MainMenu from "../../components/mainMenu";
import { getResourceDetailsAction } from "../App/actions";
import { getCategoryData, getPublicResourceData, recentActivity } from "./actions";
import "./style.scss";
import logo from "../../assets/images/logo.png";
import ProModal from "../../components/ProModal";
import { base_url } from "../../utils/constants";
import superagent from "superagent";
import Cookies from "universal-cookie";
import { Col, Container, Row } from "react-bootstrap";
import { calculatorAndToolsSlugs } from "../../utils/commonRouteUrl";
import { convertSpaceToHyphen } from "../../utils/commonFunctions";

const cookie = new Cookies();

const Resources = (props) => {
  const user_info = useSelector((state) => state.my_account.user_info);
  const [openMenu, setOpenMenu] = useState(false);
  const [selected, setSelected] = useState(0);
  const [filterView, setFilterView] = useState(true);
  const [proUpgradeModal, setProUpgradeModal] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const resourcesRef = useRef(null);
  const queryData = useRef();

  const [resourceCategory, setResourceCategory] = useState([
    {
      name: "Accounting",
      value: "accounting",
      checked: false,
    },
    {
      name: "Business",
      value: "business",
      checked: false,
    },
    {
      name: "Client Care",
      value: "client_care",
      checked: false,
    },
    {
      name: "Marketing",
      value: "marketing",
      checked: false,
    },
    {
      name: "Technology",
      value: "technology",
      checked: false,
    },
  ]);

  const resourceItemWrapRef = useRef(null);
  const [keyword, setKeyword] = useState("");

  const [filterState, setFilterState] = useState({
    categories: [],
    type: [],
    level: [],
    order: "",
    paginate: 50,
    searchQuery: "",
  });

  const [resourceType, setResourceType] = useState([
    {
      name: "How-to-guides",
      value: "how_to_guides",
      checked: false,
    },
    {
      name: "Spreadsheets",
      value: "spreadsheets",
      checked: false,
    },
    {
      name: "Calculators + Tools",
      value: "calculators_tools",
      checked: false,
    },
    {
      name: "Checklists",
      value: "checklists",
      checked: false,
    },
    {
      name: "Forms",
      value: "forms",
      checked: false,
    },
  ]);

  const [level, setLevel] = useState([
    {
      name: "Basic",
      value: "BASIC",
      checked: false,
    },
    {
      name: "Premium",
      value: "PREMIUM",
      checked: false,
    },
    {
      name: "Pro",
      value: "PRO",
      checked: false,
    },
  ]);

  const params = new URLSearchParams(document.location.search.substring(1));
  const category_data = params.get("category");
  const resoucess_data = params.get("resource_type");

  useEffect(() => {
    const stateArr = [
      calculatorAndToolsSlugs.outOfNetworkCalculator(),
      calculatorAndToolsSlugs.therapistDeductionsCalculator(),
      calculatorAndToolsSlugs.goodFaithEstimateCalculator(),
      "/therapy-note",
    ];
    if (stateArr.includes(location?.state?.from) && user_info?.subscription_type !== ("PRO" || "PRO_MONTH")) {
      setProUpgradeModal(true);
    }
  }, [location?.state?.from]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (
        location?.search === "?category=accounting" ||
        location?.search === "?category=business" ||
        location?.search === "?category=client_care" ||
        location?.search === "?category=marketing" ||
        location?.search === "?category=technology" ||
        location?.search === "?resource_type=checklists" ||
        location?.search === "?resource_type=calculators_tools" ||
        location?.search === "?resource_type=forms" ||
        location?.search === "?resource_type=how_to_guides" ||
        location?.search === "?resource_type=spreadsheets"
      ) {
        resourcesRef?.current?.scrollIntoView();
      }
    }, 1500);
    return () => {
      timeOut && clearTimeout(timeOut);
    };
  }, [location]);

  const subscribeToPro = () => {
    superagent
      .get(`${base_url}subscription/PRO`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        window.location = res.body.url;
      });
  };

  const handleChange = (value) => {
    setSelected(value.selected);
    props.getPublicResourceData(`${queryData.current}&page=${value.selected + 1}`);
    resourceItemWrapRef.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    props.getCategoryData();
    props.getResourceDetailsAction();
  }, []);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleChangePaginate = (e) => {
    setFilterState((prevState) => ({
      ...prevState,
      paginate: parseInt(e.target.value),
    }));
  };

  const handleShortChange = (e) => {
    setFilterState((prevState) => ({
      ...prevState,
      order: e.target.value,
    }));
  };

  useEffect(() => {
    if (category_data) {
      const datas = category_data?.split(",");
      const refreshData = resourceCategory?.map((item1) => {
        const item = { ...item1 };
        item.checked = datas?.includes(item.value);
        return item;
      });
      setResourceCategory(refreshData);
      setFilterState((prevState) => ({
        ...prevState,
        categories: refreshData.filter((item) => item.checked),
      }));
    }
    if (resoucess_data) {
      const datas = resoucess_data?.split(",");
      const refreshData = resourceType?.map((item1) => {
        const item = { ...item1 };
        item.checked = datas?.includes(item.value);
        return item;
      });
      setResourceType(refreshData);
      setFilterState((prevState) => ({
        ...prevState,
        type: refreshData.filter((item) => item.checked),
      }));
    }
  }, [category_data, resoucess_data]);

  const handleChangeCategory = (e) => {
    const updatedCategory = resourceCategory.map((item) => {
      const item2 = { ...item };
      if (item2.name === e.target.name) item2.checked = e.target.checked;
      return item2;
    });
    // SET FILTERSTATE AND CATEGORY STATE
    setResourceCategory([...updatedCategory]);
    setFilterState((prevState) => ({
      ...prevState,
      categories: updatedCategory.filter((x) => x.checked),
    }));
  };

  const handleChangeResources = (e) => {
    const updatedCategory = resourceType.map((item) => {
      const item2 = { ...item };
      if (item2.value === e.target.name) item2.checked = e.target.checked;
      return item2;
    });
    // SET FILTERSTATE AND RESOURCES STATE
    setResourceType([...updatedCategory]);
    setFilterState((prevState) => ({
      ...prevState,
      type: updatedCategory.filter((x) => x.checked),
    }));
  };

  const handleChangeLevel = (e) => {
    const updatedCategory = level.map((item) => {
      const item2 = { ...item };
      if (item2.name === e.target.name) item2.checked = e.target.checked;
      return item2;
    });
    // SET FILTERSTATE AND LEVEL STATE
    setLevel([...updatedCategory]);
    setFilterState((prevState) => ({
      ...prevState,
      level: updatedCategory.filter((x) => x.checked),
    }));
  };

  const handleClickTop = (id, category) => {
    if (user_info?.auth_token) {
      recentActivity("viewed", category, id);
    }

    window.scrollTo(0, 0);
  };

  const handleClear = () => {
    setResourceCategory([
      {
        name: "Accounting",
        value: "accounting",
        checked: false,
      },
      {
        name: "Business",
        value: "business",
        checked: false,
      },
      {
        name: "Client Care",
        value: "client_care",
        checked: false,
      },
      {
        name: "Marketing",
        value: "marketing",
        checked: false,
      },
      {
        name: "Technology",
        value: "technology",
        checked: false,
      },
    ]);

    setLevel([
      {
        name: "Basic",
        value: "BASIC",
        checked: false,
      },
      {
        name: "Premium",
        value: "PREMIUM",
        checked: false,
      },
      {
        name: "Pro",
        value: "PRO",
        checked: false,
      },
    ]);

    setResourceType([
      {
        name: "How-To-Guides",
        value: "how_to_guides",
        checked: false,
      },
      {
        name: "Spreadsheets",
        value: "spreadsheets",
        checked: false,
      },
      {
        name: "Calculators + Tools",
        value: "calculators_tools",
        checked: false,
      },
      {
        name: "Checklists",
        value: "checklists",
        checked: false,
      },
      {
        name: "Forms",
        value: "forms",
        checked: false,
      },
    ]);

    setFilterState({
      categories: [],
      type: [],
      level: [],
      order: "",
      searchQuery: "",
      paginate: 50,
    });

    history.push("/resources");
    props.getPublicResourceData("paginate=50");
  };
  // BUILD QUERY FOR API CALL
  useEffect(() => {
    // Map through the filters, get the required value, make an array and join them with an '&'
    const categories = filterState.categories
      .map((category) => {
        return `category[]=${category.name}`;
      })
      .join("&");

    const resourceType = filterState.type
      .map((type) => {
        return `resource_type[]=${type.value}`;
      })
      .join("&");

    const levelType = filterState.level
      .map((level) => {
        return `display_type[]=${level.value}`;
      })
      .join("&");

    // Only add the query if that part of the query is available and then inlude an '&'
    const q = `${categories && categories + "&"}${resourceType && resourceType + "&"}${levelType && levelType + "&"}order=${filterState.order}&paginate=${
      filterState.paginate
    }&searchKeyword=${filterState.searchQuery}`;
    queryData.current = q;
  }, [filterState]);

  // CHANGE ROUTE BASED ON FILTER
  useEffect(() => {
    const categories_route =
      filterState.categories?.length > 0 &&
      "category=" +
        filterState.categories
          .map((category_item) => {
            return category_item.value;
          })
          .join(",");

    const resourceType_route =
      filterState.type?.length > 0 &&
      "resource_type=" +
        filterState.type
          .map((type_item) => {
            return type_item.value;
          })
          .join(",");

    const levelType_route =
      filterState.level?.length > 0 &&
      "level_type=" +
        filterState.level
          .map((level_item) => {
            return level_item.name;
          })
          .join(",");

    const route1 = filterState.type?.length > 0 ? "&" : "";
    const route2 = filterState.level?.length > 0 ? "&" : "";

    const category_route = () => {
      return categories_route ? `${categories_route}${route1}` : "";
    };
    const resource_route = () => {
      return resourceType_route ? `${resourceType_route}${route2}` : "";
    };
    const level_route = () => {
      return levelType_route ? `${route2}${levelType_route}` : "";
    };
    if (location?.state?.megamenu) {
      setFilterState((prevState) => ({
        ...prevState,
        level: [],
      }));
      history.push(`/resources?${categories_route}`);
    } else if (location?.state?.megamenu1) {
      setFilterState((prevState) => ({
        ...prevState,
        level: [],
      }));
      history.push(`/resources?${resourceType_route}`);
    } else {
      const q = `${category_route()}${resource_route()}${level_route()}`;
      history.push(`/resources?${q}`);
    }
  }, [filterState]);

  useEffect(() => {
    if (category_data && queryData.current !== "order=&paginate=50&searchKeyword=") {
      props.getPublicResourceData(`${queryData.current}`);
      const newState = resourceCategory?.map((obj) => (category_data?.split(",").includes(obj.value) ? { ...obj, checked: true } : { ...obj, checked: false }));
      if (location?.state?.megamenu) {
        setFilterState((prevState) => ({
          ...prevState,
          categories: newState.filter((x) => x.checked),
          type: [],
        }));
        setResourceCategory(newState);
        setResourceType([
          {
            name: "How-To-Guides",
            value: "how_to_guides",
            checked: false,
          },
          {
            name: "Spreadsheets",
            value: "spreadsheets",
            checked: false,
          },
          {
            name: "Calculators + Tools",
            value: "calculators_tools",
            checked: false,
          },
          {
            name: "Checklists",
            value: "checklists",
            checked: false,
          },
          {
            name: "Forms",
            value: "forms",
            checked: false,
          },
        ]);
        setLevel([
          {
            name: "Basic",
            value: "BASIC",
            checked: false,
          },
          {
            name: "Premium",
            value: "PREMIUM",
            checked: false,
          },
          {
            name: "Pro",
            value: "PRO",
            checked: false,
          },
        ]);
      }
    }
    if (resoucess_data && queryData.current !== "order=&paginate=50&searchKeyword=") {
      props.getPublicResourceData(`${queryData.current}`);
      const newState = resourceType?.map((obj) => (resoucess_data?.split(",").includes(obj.value) ? { ...obj, checked: true } : { ...obj, checked: false }));
      if (location?.state?.megamenu1) {
        setFilterState((prevState) => ({
          ...prevState,
          type: newState.filter((x) => x.checked),
          categories: [],
        }));
        setResourceType(newState);
        setResourceCategory([
          {
            name: "Accounting",
            value: "accounting",
            checked: false,
          },
          {
            name: "Business",
            value: "business",
            checked: false,
          },
          {
            name: "Client Care",
            value: "client_care",
            checked: false,
          },
          {
            name: "Marketing",
            value: "marketing",
            checked: false,
          },
          {
            name: "Technology",
            value: "technology",
            checked: false,
          },
        ]);
        setLevel([
          {
            name: "Basic",
            value: "BASIC",
            checked: false,
          },
          {
            name: "Premium",
            value: "PREMIUM",
            checked: false,
          },
          {
            name: "Pro",
            value: "PRO",
            checked: false,
          },
        ]);
      }
    }
  }, [filterState, queryData.current]);

  useEffect(() => {
    if (!category_data && !resoucess_data) {
      setSelected(0);
      props.getPublicResourceData(`${queryData.current}`);
    }
  }, [queryData.current]);

  useEffect(() => {
    if (props?.resource_cms?.keyword?.length > 0) {
      const dataKeyword = props?.resource_cms?.keyword;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.resource_cms?.keyword]);

  function replaceJSX(str, replace) {
    const result = [];
    for (let i = 0; i < str?.length; i++) {
      result.push(str[i].toUpperCase());
      if (i < str.length - 1) {
        result.push(replace);
      }
    }
    return result;
  }
  const handleSearchQueryChange = (e) => {
    setFilterState((prevState) => ({
      ...prevState,
      searchQuery: e.target.value,
    }));
  };
  const [monthly, setMonthly] = useState(false);
  useEffect(() => (document.getElementById("heroimg").style.backgroundImage = `url('${props.resource_cms?.hero_image}')`), [props.resource_cms?.hero_image]);
  return (
    <>
      <Helmet>
        <title>Resources for Private Practice Therapists - Clarity Cooperative</title>
        <meta name="title" content={"Resources for Private Practice Therapists - Clarity Cooperative"} />
        <meta name="description" content={props?.resource_cms?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Resources for Private Practice Therapists - Clarity Cooperative"} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.resource_cms?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.resource_cms?.excerpt} />
        <meta name="twitter:card" content={props?.resource_cms?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.resource_cms?.url} />
        <meta name="twitter:title" content={"Resources for Private Practice Therapists - Clarity Cooperative"} />
        <meta name="twitter:description" content={props?.resource_cms?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
      {/* {isLoading ? (
        <Loader />
      ) : ( */}
      <>
        <div className="position-relative">
          <div className="bgsection position-absolute w-100 h-100" id="heroimg"></div>
          <div className="bgsection-inner position-relative">
            <Container>
              <div className="spacing"></div>
              <Row className="justify-content-center text-center">
                <Col sm={11} md={10} lg={8} xl={6} xxl={5}>
                  <h2>{props.resource_cms?.hero_title}</h2>
                  <p>{props.resource_cms?.hero_paragraph}</p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Element name="resource_section">
          <Container>
            <Row className="align-items-center justify-content-center">
              <Col sm={11} md={10} lg={9} xl={8}>
                <div className="p-3 shadow position-relative rounded-3 my-5">
                  <input
                    className="form-control bg-white p-0 border-0 shadow-none"
                    type="text"
                    placeholder="Search resource"
                    onChange={handleSearchQueryChange}
                    value={filterState.searchQuery}
                  />
                  <i className="fa fa-search searchBox position-absolute top-50 end-0 translate-middle-y me-4"></i>
                </div>
              </Col>
            </Row>
            <div className="d-flex align-items-center justify-content-between w-100 border-bottom mb-4 pb-3">
              <h6 className="mb-0">Filter</h6>
              <div onClick={() => setFilterView(!filterView)}>
                {filterView ? (
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2.03125" y="0.869141" width="24" height="1.5" transform="rotate(45 2.03125 0.869141)" fill="#071446" />
                    <rect x="19" y="1.92969" width="24" height="1.5" transform="rotate(135 19 1.92969)" fill="#071446" />
                  </svg>
                ) : (
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line y1="0.75" x2="20" y2="0.75" stroke="#071446" strokeWidth="1.5" />
                    <line y1="6.75" x2="20" y2="6.75" stroke="#071446" strokeWidth="1.5" />
                    <line y1="12.75" x2="20" y2="12.75" stroke="#071446" strokeWidth="1.5" />
                  </svg>
                )}
              </div>
            </div>

            {filterView ? (
              <>
                <Row className="gy-md-0 gy-2">
                  <Col sm={6} md={3}>
                    <label htmlFor="resourceType" className="fw-bold text-darkblue text-capitalize">
                      Select Categories
                    </label>
                    {resourceCategory?.map((item, i) => (
                      <div class="form-check my-2" key={item.name}>
                        <input
                          id={"categories" + i}
                          onChange={handleChangeCategory}
                          checked={item.checked}
                          type="checkbox"
                          name={item.name}
                          className="form-check-input"
                        />
                        <label className="text-darkblue" htmlFor={"categories" + i}>
                          {item.name}
                        </label>
                      </div>
                    ))}
                  </Col>
                  <Col sm={6} md={3}>
                    <label htmlFor="resourceType" className="fw-bold text-darkblue text-capitalize">
                      Resource Type
                    </label>

                    {resourceType?.map((item, i) => (
                      <div class="form-check my-2" key={item.name}>
                        <input
                          id={"resource" + i}
                          onChange={handleChangeResources}
                          checked={item.checked}
                          type="checkbox"
                          name={item.value}
                          className="form-check-input"
                        />
                        <label className="text-darkblue" htmlFor={"resource" + i}>
                          {item.name}
                        </label>
                      </div>
                    ))}
                  </Col>
                  <Col sm={6} md={3}>
                    <label htmlFor="resourceType" className="fw-bold text-darkblue text-capitalize">
                      level
                    </label>

                    {level?.map((item, i) => (
                      <div class="form-check my-2" key={item.name}>
                        <input
                          id={"level" + i}
                          onChange={handleChangeLevel}
                          checked={item.checked}
                          type="checkbox"
                          name={item.name}
                          className="form-check-input"
                        />
                        <label className="text-darkblue" htmlFor={"level" + i}>
                          {item.name}
                        </label>
                      </div>
                    ))}
                  </Col>
                  <Col sm={6} md={3} className="pb-3">
                    <label className="text-darkblue text-capitalize" htmlFor="sortBy">
                      Sort By
                    </label>
                    <select className="form-select" onChange={handleShortChange} name="sortBy" id="sortBy" value={filterState.order}>
                      <option value="">Sort By</option>
                      <option value="newest">Newest to Oldest</option>
                      <option value="oldest">Oldest to Newest</option>
                      <option value="a-z">Alphabetical (A-Z)</option>
                      <option value="z-a">Alphabetical (Z-A)</option>
                    </select>

                    <label className="text-darkblue text-capitalize mt-4" htmlFor="show">
                      Show
                    </label>
                    <select className="form-select" value={filterState.paginate} onChange={handleChangePaginate} id="show">
                      <option value="5">Showing 5</option>
                      <option value="10">Showing 10</option>
                      <option value="25">Showing 25</option>
                      <option value="50">Showing 50</option>
                    </select>
                  </Col>
                </Row>
                <button onClick={handleClear} type="button" className="btn btn-primary mt-3">
                  Clear Filter
                </button>
              </>
            ) : null}

            <div ref={resourcesRef} className="mt-5">
              {props.resources_list?.data?.length ? (
                <>
                  <Row ref={resourceItemWrapRef} className="pb-3">
                    {props.resources_list?.data?.map((item, i) => (
                      <Col sm={6} lg={4} xl={3} key={item.id} className="featuredResource p-3">
                        <div className="h-100 featuredResource-inner shadow" style={{ borderRadius: "18px 18px 0 0" }}>
                          <NavLink
                            className="text-darkblue"
                            to={`/resources/${item.id}/${item.url?.toLowerCase()}`}
                            onClick={() => {
                              handleClickTop(item.id, item);
                            }}
                          >
                            <div
                              className="featureImage position-relative overflow-hidden rounded-top-3"
                              style={{
                                borderBottom: "solid 7px",
                                borderBottomColor: `${
                                  (item.resource_color === "pink/yellow" && "#F29EC6") ||
                                  (item.resource_color === "blue/purple" && "#777DEF") ||
                                  (item.resource_color === "purple/green" && "#A3ACFB") ||
                                  (item.resource_color === "green/yellow" && "#7ADBD1") ||
                                  (item.resource_color === "blue/lightBlue" && "#54A7D9") ||
                                  (item.resource_color === "green/teal" && "#00C998")
                                }`,
                              }}
                            >
                              <img
                                className="position-absolute w-100 h-100"
                                src={item.thumbnail}
                                alt={`${convertSpaceToHyphen(item?.name)}-clarity-cooperative`}
                                loading="lazy"
                              />
                              <div className="position-absolute top-0 left-0 w-100 d-flex align-items-center justify-content-end p-3">
                                {/* {item.categories?.split(",").map((item, index) => (
                                  <span className="text-white text-uppercase" key={index}>
                                    {item}
                                  </span>
                                ))} */}
                                {/* <span className="bg-darkblue text-white px-2 py-0 fw-bold text-uppercase bg-blue">New</span> */}
                              </div>
                              <div className="position-absolute bottom-0 left-0 w-100 p-3">
                                <span className="px-2 py-1 fw-bold text-uppercase bg-white text-dark-blue d-inline-block">Level: {item.display_type}</span>
                              </div>
                            </div>
                            <div className="p-4">
                              <span
                                style={{
                                  color: `${
                                    (item.resource_color === "pink/yellow" && "#F29EC6") ||
                                    (item.resource_color === "blue/purple" && "#777DEF") ||
                                    (item.resource_color === "purple/green" && "#A3ACFB") ||
                                    (item.resource_color === "green/yellow" && "#7ADBD1") ||
                                    (item.resource_color === "blue/lightBlue" && "#54A7D9") ||
                                    (item.resource_color === "green/teal" && "#00C998")
                                  }`,
                                }}
                                className="categoryLabel fs-12 fw-bold"
                              >
                                {replaceJSX(item?.categories?.split(","), <span className="categoryLabelSeparate">.</span>)}
                              </span>
                              <h6>{item.name}</h6>
                              <p>{item.excerpt}</p>
                            </div>
                          </NavLink>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  {props.resources_list?.total > props.resources_list?.per_page && (
                    <ReactPaginate
                      containerClassName="paginationWrapper"
                      pageCount={props.resources_list.last_page}
                      pageRangeDisplayed={props.resources_list.per_page}
                      onPageChange={handleChange}
                      nextLabel={<img src={angleRight} alt="right" />}
                      previousLabel={<img src={angleLeft} alt="left" />}
                      forcePage={selected}
                    />
                  )}
                </>
              ) : (
                <div className="border p-5 text-center rounded-3 mt-5 mb-3 mb-xl-5">
                  <h5>We apologize! We couldn't find any results.</h5>

                  <button type="button" className="btn btn-primary">
                    Keep Searching
                  </button>
                </div>
              )}
            </div>
          </Container>
        </Element>
      </>
      {/* )}  */}
      <Footer />
      <FooterBottom />
      {proUpgradeModal && (
        <ProModal
          isOpen={proUpgradeModal}
          onClosed={() => setProUpgradeModal(false)}
          title="Unlock Pro Features"
          content="Do you like what you’ve experienced so far? Unlock more potential:"
          price="$199"
          Flag="Year"
          submit={subscribeToPro}
          submitBtn
          values={subscribeToPro}
          isFreeTrial={false}
          monthly={monthly}
          setMonthly={setMonthly}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  resources_list: state.resources.resources_list,
  resource_cms: state.cms.resource_cms,
  categories: state.resources.public_cat,
});

export default connect(mapStateToProps, {
  getPublicResourceData,
  getResourceDetailsAction,
  getCategoryData,
})(Resources);
